import { Routes, Route } from "react-router-dom";
import { LoginPage } from "../views/view.exports";

const AuthPages = () => {
  return (
    <Routes>
      <Route index element={<LoginPage />} />
      <Route path="*" element={<LoginPage />} />
    </Routes>
  );
};

export default AuthPages;
